export const replaceCDNToOrigin = url => {
  const parsedUrl = new URL(url);
  const pathname = parsedUrl.pathname;
  const sameOriginWorkerUrl = new URL(pathname, globalThis.location.origin);
  return sameOriginWorkerUrl;
};